import $paths from "@/constants/route-paths";
import { appConfig } from "@/config";

// Application layouts
const { layouts } = appConfig;

/** Routes meta  */
const meta = { layout: layouts.app, requiresAuth: true };

const mailboxRoutes = [
  {
    path: $paths.mailboxProviders,
    name: "manage-mailbox-providers",
    meta,
    component: () =>
      import("@/views/MailboxProviders/ManageMailboxProvider.vue"),
  },
  {
    path: $paths.createMailboxProvider,
    name: "create-mailbox-provider",
    meta,
    component: () =>
      import("@/views/MailboxProviders/CreateMailboxProvider.vue"),
  },
  {
    path: $paths.mailboxProvider,
    name: "mailbox-provider",
    meta,
    component: () => import("@/views/MailboxProviders/MailboxProvider.vue"),
  },
];

export default mailboxRoutes;
